import UserBase from '../user-base.entity';

export default class DepartmentPermissionEntity extends UserBase {
	department_head: number;
	admin_access: number;
	edit_data: number;
	budget_access?: number;
	fitting_research?: number;

	isDeptHead(): boolean {
		return !!this.department_head;
	}

	canAddUser(): boolean {
		return !!this.admin_access;
	}

	canEdit(): boolean {
		return !!this.edit_data;
	}

	canAccessBudget(): boolean {
		return !!this.budget_access;
	}

	canAccessFittingResearch(): boolean {
		return !!this.fitting_research;
	}
}
